import React, { useRef, useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Select from "../select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Button from "../button";
import DownloadButton from "../download-buttons";
import { formatDate } from "../../../algorithms/date";
import TotalRecords from "../total-records/index";
import { useQuery } from "@apollo/client";
import { QUERY_SUSPICIOUS_NUMBERS } from "../../../constants/graphql/drop-off-graphql";

function getNestedValue(obj, keys, index) {
  if (!obj || typeof obj !== "object") {
    return undefined; // Handle non-object cases or null objects
  }

  const key = keys.shift();
  let keyVal;
  if (typeof key === "object") {
    keyVal = key.val;
  } else {
    keyVal = key;
  }
  if (keyVal in obj) {
    if (keys.length === 0) {
      return obj[keyVal]; // Reached the final nested property
    } else {
      if (Array.isArray(obj[keyVal]) && obj[keyVal][index]) {
        return getNestedValue(obj[keyVal][index], keys);
      }
      return getNestedValue(obj[keyVal], keys); // Continue recursively
    }
  } else {
    return undefined; // Property doesn't exist
  }
}
export default function TableWithHeader({
  header = [
    { header_name: "Column1", key: "column1", tag: "date" },
    { header_name: "Column2", key: "column2" },
    { header_name: "Column3", key: "column3" },
  ],
  title = "Insert a title",
  item = [
    {
      column1: "Sample 1",
      column2: "Sample 2",
      column3: "Sample 3",
    },
    {
      column1: "Sample 1",
      column2: "Sample 2",
      column3: "Sample 3",
    },
    {
      column1: "Sample 1",
      column2: "Sample 2",
      column3: "Sample 3",
    },
    // Add more items as needed
  ],
  action,
  itemsPerPage = 5, // Number of items to display per page
  showHeader = true,
  children,
  withLink = true,
  linkField,
  actionEvent,
  fieldId,
  fileName = "download",
  cellSelection = true,
  selectionMode = "single",
}) {
  console.log({ ITEM_DETAILS: item, cellSelection });
  const fetchNumber = useQuery(QUERY_SUSPICIOUS_NUMBERS);
  const [suspiciousNumber, setsuspiciousNumber] = useState([]);
  const [tableData, setTableData] = useState(item);

  useEffect(() => {
    setTableData(item);
  }, [item]);

  useEffect(() => {
    if (fetchNumber.data) {
      var tempArr = [];
      fetchNumber.data.suspiciousAgents.forEach((d) => {
        tempArr.push(d.recipientMobile);
      });
      setsuspiciousNumber(tempArr);
    }
  }, [fetchNumber.data]);

  const getStatusWithSuspendedCheck = (rowData) => {
    if (rowData.agentStatus === "-1" || rowData.agentStatus === -1) {
      const statusComments = rowData.agentStatusComments?.toLowerCase().trim();
      const comments = rowData.comments?.toLowerCase().trim();

      if (
        statusComments?.includes("suspended") ||
        comments?.includes("suspended")
      ) {
        return "Suspended";
      }
      return "Blocked";
    }

    return "Active";
  };

  const dt = useRef(null);
  const navigate = useNavigate();
  const actionEventTemplate = (row) => {
    return (
      <Button
        value={"History"}
        className="p-2"
        onClick={(e) => actionEvent(e, row)}
      />
    );
  };
  const dateTemplate = (rowData, data) => {
    return <p>{formatDate(rowData[data.column.props.field].split("T")[0])}</p>;
  };

  const numTemplate = (rowData, data) => {
    if (suspiciousNumber.includes(rowData[data.column.props.field])) {
      return (
        <p className="text-red-500 text-bold w-max">
          👎{rowData[data.column.props.field].substring(2)}
        </p>
      );
    }
    return rowData[data.column.props.field].substring(2);
  };

  // useEffect(() => {
  // 	if(item.agentStatusComments !== ""){
  // 		// look for the word "suspended".
  // 		// if found, change the text of the original agentStatus
  // 	}
  // })

  console.log({ item });
  return (
    <>
      <TotalRecords count={item.length} />
      <DownloadButton dt={dt} csvOnly={true} />
      <div className="w-full h-1 bg-yellow-400"></div>
      <div className="border-2 border-stone-400">
        <div
          className={`bg-primary-primaryYellow p-2 border-b-2 border-stone-400 ${
            !showHeader && "hidden"
          }`}
        >
          <p className="text-xl text-center font-bold">{title}</p>
        </div>
        <DataTable
          paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
          currentPageReportTemplate="Rows per page"
          // currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records |  Rows per page"
          paginator
          paginatorRight
          rowsPerPageOptions={[10, 20, 50]}
          rows={10}
          showGridlines={true}
          stripedRows
          value={tableData}
          sortMode="multiple"
          exportFilename={fileName}
          removableSort
          cellSelection={cellSelection}
          selectionMode={cellSelection === false ? null : selectionMode}
          ref={dt}
          onSelectionChange={(event) => {
            const { cellIndex, rowData } = event.value;
            console.log(cellIndex);
            const { partnerAgentId } = rowData;
            if (cellIndex === 0) {
              window.open(`${linkField[1]}/${partnerAgentId}`, "_blank");
            }
          }}
          tableStyle={{ minWidth: "50rem" }}
          emptyMessage={
            <div className="text-red-500 font-bold">NO RESULT FOUND</div>
          }
        >
          {header.map((data, key) => {
            if (data.key == "blank") {
              return (
                <Column
                  field={data.key}
                  header={data.header_name}
                  style={{ display: "none" }}
                ></Column>
              );
            }
            if (linkField && linkField[0] === data.key) {
              return (
                <Column
                  className="hello"
                  onCellEditComplete={() => {
                    console.log("hello");
                  }}
                  o
                  field={data.key}
                  header={data.header_name}
                  sortable
                  style={{ width: "20%" }}
                  headerStyle={{
                    backgroundColor: "#facc15",
                    color: "black",
                  }}
                  bodyStyle={{ fontWeight: "bold" }}
                ></Column>
              );
            }
            if (data.tag === "date") {
              return (
                <Column
                  field={data.key}
                  sortable
                  body={dateTemplate}
                  header={data.header_name}
                  headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
                ></Column>
              );
            }
            if (data.tag === "number") {
              return (
                <Column
                  field={data.key}
                  sortable
                  body={numTemplate}
                  header={data.header_name}
                  headerStyle={{ width: "3rem", backgroundColor: "#FECD08" }}
                ></Column>
              );
            }
            if (fieldId && data.key === fieldId && actionEvent) {
              return (
                <Column
                  style={{ width: "20%" }}
                  field={data.key}
                  header={data.header_name}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                  body={actionEventTemplate}
                ></Column>
              );
            }

            if (data.key === "agentStatus" && data.tag === "custom") {
              return (
                <Column
                  field={data.key}
                  header={data.header_name}
                  sortable
                  style={{ width: "20%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                  body={(rowData) => {
                    return <p>{getStatusWithSuspendedCheck(rowData)}</p>;
                    // return "HEHEHEHHEHE";
                  }}
                ></Column>
              );
            }

            return (
              <Column
                field={data.key}
                header={data.header_name}
                sortable
                style={{ width: "20%" }}
                headerStyle={{ backgroundColor: "#facc15", color: "black" }}
              ></Column>
            );
          })}
        </DataTable>
        {/* {renderPagination()} */}
        <div className="mt-2"></div>
      </div>
    </>
  );
}
